import { useState } from "react";

// import UploadCatalog from "./AdminUploadCatalog";
import AdminUploadCatalog from "../PDFFiles/AdminUploadCatalogs";
import CatalogList from "../PDFFiles/CatalogAdminList"

function CatalogAdminPage() {
  const [reload, setReload] = useState(false);

  return (
    <div>
      <h2>Каталоги</h2>

      {/* Форма загрузки */}
      <AdminUploadCatalog onUploaded={() => setReload(!reload)} />

      {/* Список + удаление */}
      <CatalogList key={reload} />
    </div>
  );
}

export default CatalogAdminPage;